module.exports = __webpack_public_path__ + "static/media/postbot.gb.605b7db7.zip";